import type { CatalogSchema } from "../../studio/schemas/catalog-schema.js";
import { CatalogItemStatus } from "../../studio/schemas/catalog-schema.js";

const template = document.createElement("template");
template.innerHTML = `
  <div style="display: flex; height: 100%; width: 100%;">
    <main style="flex: 1; padding: var(--space-6); overflow-y: auto; background: var(--color-graphite-50);">
      <div id="canvas" style="width: 100%; max-width: 800px; margin: 0 auto; background: var(--color-surface-primary); min-height: 100%; border: 1px solid var(--color-graphite-300); border-radius: var(--radius-md); padding: var(--space-8); box-shadow: var(--shadow-sm);">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: var(--space-4);">
          <h2 style="font-size: var(--font-size-lg); color: var(--color-text-muted); margin: 0;">Catalog Items</h2>
          <button id="add-item-btn" class="btn-primary" style="background-color: var(--color-primary); color: var(--color-text-primary); border: none; padding: var(--space-2) var(--space-4); border-radius: var(--radius-md); font-weight: 500; cursor: pointer;">Add Item</button>
        </div>
        
        <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: var(--font-size-sm);">
          <thead>
            <tr style="border-bottom: 2px solid var(--color-graphite-300);">
              <th style="padding: var(--space-2); color: var(--color-text-secondary);">Code</th>
              <th style="padding: var(--space-2); color: var(--color-text-secondary);">Label</th>
              <th style="padding: var(--space-2); color: var(--color-text-secondary);">Status</th>
              <th style="padding: var(--space-2); color: var(--color-text-secondary);">Actions</th>
            </tr>
          </thead>
          <tbody id="items-container"></tbody>
        </table>
      </div>
    </main>
  </div>
`;

export class CatalogBuilder extends HTMLElement {
  private schema: CatalogSchema = { items: [] };
  private onSchemaChangeCallback: ((schema: CatalogSchema) => void) | null = null;

  constructor() {
    super();
    this.appendChild(template.content.cloneNode(true));
  }

  public connectedCallback() {
    this.querySelector("#add-item-btn")?.addEventListener("click", () => {
      this.schema.items.push({
        id: crypto.randomUUID(),
        code: "ITEM_" + Date.now().toString().slice(-4),
        label: "New Item",
        order: this.schema.items.length,
        status: CatalogItemStatus.Active
      });
      this.notifyChange();
      this.renderCanvas();
    });
    this.renderCanvas();
  }

  public setSchema(schema: CatalogSchema) {
    this.schema = JSON.parse(JSON.stringify(schema));
    if (!this.schema.items) this.schema.items = [];
    this.renderCanvas();
  }

  public onSchemaChange(callback: (schema: CatalogSchema) => void) {
    this.onSchemaChangeCallback = callback;
  }

  private notifyChange() {
    if (this.onSchemaChangeCallback) {
      this.onSchemaChangeCallback(JSON.parse(JSON.stringify(this.schema)));
    }
  }

  private renderCanvas() {
    const container = this.querySelector("#items-container")!;
    container.innerHTML = "";

    this.schema.items.forEach(item => {
      const tr = document.createElement("tr");
      tr.style.borderBottom = "1px solid var(--color-graphite-200)";
      
      tr.innerHTML = `
        <td style="padding: var(--space-2);">
          <input type="text" class="code-input" value="${item.code}" style="width: 100%; padding: 4px; border: 1px solid var(--color-graphite-300); border-radius: 4px;">
        </td>
        <td style="padding: var(--space-2);">
          <input type="text" class="label-input" value="${item.label}" style="width: 100%; padding: 4px; border: 1px solid var(--color-graphite-300); border-radius: 4px;">
        </td>
        <td style="padding: var(--space-2);">
          <select class="status-input" style="padding: 4px; border: 1px solid var(--color-graphite-300); border-radius: 4px;">
            <option value="ACTIVE" ${item.status === 'ACTIVE' ? 'selected' : ''}>Active</option>
            <option value="INACTIVE" ${item.status === 'INACTIVE' ? 'selected' : ''}>Inactive</option>
          </select>
        </td>
        <td style="padding: var(--space-2);">
          <button class="delete-btn" style="color: red; background: none; border: none; cursor: pointer;">Excluir</button>
        </td>
      `;

      tr.querySelector(".code-input")?.addEventListener("input", (e) => {
        item.code = (e.target as HTMLInputElement).value;
        this.notifyChange();
      });
      tr.querySelector(".label-input")?.addEventListener("input", (e) => {
        item.label = (e.target as HTMLInputElement).value;
        this.notifyChange();
      });
      tr.querySelector(".status-input")?.addEventListener("change", (e) => {
        item.status = (e.target as HTMLSelectElement).value as CatalogItemStatus;
        this.notifyChange();
      });
      tr.querySelector(".delete-btn")?.addEventListener("click", () => {
        this.schema.items = this.schema.items.filter(i => i.id !== item.id);
        this.notifyChange();
        this.renderCanvas();
      });

      container.appendChild(tr);
    });
  }
}
if (!customElements.get("app-catalog-builder")) {
  customElements.define("app-catalog-builder", CatalogBuilder);
}

